'use client';

import Script from 'next/script';

export default function JsonLdScript({ data }) {
  return (
    <Script
      id='json-ld'
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      strategy='afterInteractive'
    />
  );
}
